export default "__VITE_ASSET__CNQhGmYt__"